import debounce from 'lodash/debounce';
import { lStorage } from '../';

export const INTERVAL_TIME = 10 * 1000;
const DEBOUNCE_TIME = 200;
const STORAGE_KEY = 'tabTimestamp';

export default class IdleTimer {
	get lastAction() {
		return lStorage.get({ key: STORAGE_KEY });
	}

	set lastAction(value) {
		lStorage.set({ key: STORAGE_KEY, value });
	}

	constructor({ rulesGenerator, onAction }) {
		if (!this.lastAction) {
			this.lastAction = this.getCurrentTime();
		}

		this.events = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
		this.timerStoped = false;
		this.intervalId = setInterval(
			this.checkUserActions(rulesGenerator),
			INTERVAL_TIME
		);
		this.resetCallback = this.resetTimer(onAction);
		this.addEvents();
	}

	getCurrentTime = () => Math.round(new Date().getTime() / 1000);

	addEvents = () => {
		this.events.forEach(eventStr => {
			window.addEventListener(eventStr, this.resetCallback);
		});
	};

	removeEvents = () => {
		this.events.forEach(eventStr => {
			window.removeEventListener(eventStr, this.resetCallback);
		});
	};

	clearTimer = () => {
		this.removeEvents();
		clearInterval(this.intervalId);
	};

	stopActionsRecording = () => {
		this.timerStoped = true;
	};

	startActionsRecording = () => {
		this.timerStoped = false;
		this.lastAction = this.getCurrentTime();
	};

	resetTimer = onAction =>
		debounce(() => {
			if (this.timerStoped || !lStorage.get({ key: 'current-user' })) return;

			this.lastAction = this.getCurrentTime();
			onAction(this.lastAction);
		}, DEBOUNCE_TIME);

	checkUserActions = rulesGenerator => () => {
		const diffInSeconds = this.getCurrentTime() - this.lastAction;
		const rules = Array.isArray(rulesGenerator)
			? rulesGenerator
			: rulesGenerator(diffInSeconds);

		rules.forEach(
			({ condition, action }) => condition && action(diffInSeconds)
		);
	};
}
